import { render, staticRenderFns } from "./sub_common.vue?vue&type=template&id=42fbde00&scoped=true"
import script from "./sub_common.vue?vue&type=script&lang=js"
export * from "./sub_common.vue?vue&type=script&lang=js"
import style0 from "./sub_common.vue?vue&type=style&index=0&id=42fbde00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fbde00",
  null
  
)

export default component.exports